/** @jsxImportSource @emotion/react */
import { Dropdown } from "primereact/dropdown";
import * as estilos from "./estilosGenerador";

// Pregunta con opciones. En pantallas angostas el selector baja debajo de la
// pregunta y toma todo el ancho, en vez de salirse de la tarjeta.
export default function DropdownGeneradorEtiquetas({ titulo, opciones, cambioConfiguracion, id, valor }) {
  return (
    <div css={estilos.filaControl}>
      <label htmlFor={id} css={estilos.pregunta}>
        {titulo}
      </label>
      <Dropdown
        inputId={id}
        options={opciones}
        optionLabel="etiqueta"
        optionValue="value"
        value={valor !== undefined ? valor : "0"}
        onChange={(e) => {
          cambioConfiguracion({ target: { value: e.value } }, id);
        }}
        css={estilos.control}
      />
    </div>
  );
}
